import { createContext } from 'react';
import { TenantConfig } from 'types';

export const EditTenantModalContext = createContext<{ open: (tenant: TenantConfig) => void }>({ open: () => {} });
